import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const ColorPickersContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const Divider = styled(Box)`
  width: 5px;
`;
